<template>
    <AdminLayout>
        <template #header>
            <Breadcrumb :items="items" />
        </template>
        <div class="container">
            <SettingsPage :user="user" @update-profile="updateProfile" />
        </div>
    </AdminLayout>
</template>

<script setup>
import { ref, computed } from "vue";
import AdminLayout from "@/layout/AdminLayout.vue";
import SettingsPage from "@/components/dashboard/admin/settingsPage.vue";
import Breadcrumb from "@/components/CustomBreadcrumb.vue"
import { useAuthStore } from "@/stores/authStore";
import { updateUsername, updatePassword, updateEmail } from "@/api/admin";
import { useToast } from "primevue/usetoast";
const toast = useToast();

const authStore = useAuthStore();
const items = ref([{ label: "Settings" }]);
const user = computed(() => authStore.user);


const updateProfile = async (userData) => {
    try {
        const updateTasks = [];

        if (userData.userName) {
            updateTasks.push(updateUsername({ username: userData.userName }));
        }

        if (userData.email) {
            updateTasks.push(updateEmail({ email: userData.email }));
        }

        if (userData.currentPassword && userData.newPassword) {
            updateTasks.push(
                updatePassword({
                    password: userData.currentPassword,
                    newPassword: userData.newPassword
                })
            );
        }

        const results = await Promise.allSettled(updateTasks);

        const failed = results.find(r => r.status === "rejected");

        if (failed) {
            toast.add({
                severity: "error",
                summary: "Update Failed",
                detail: failed.reason?.response?.data?.message,
                life: 3000
            });
        } else {
            toast.add({
                severity: "success",
                summary: "Update Successful",
                detail: "Your profile has been successfully updated.",
                life: 3000
            });
        }
    } catch (error) {
        console.error("Failed to update profile:", error);
        toast.add({
            severity: "error",
            summary: "Update Failed",
            detail: error?.response?.data?.message || "An unexpected error occurred.",
            life: 3000
        });
    }
};



</script>

<style>
.container {
    width: 100%;
    height: auto;
    border-radius: 8px;
}
</style>